import {
  InnerContentItem,
  OuterContentItem,
  PrimaryTag,
  useFormatDisplayDate,
} from "@certn/cascadia-react";
import { CascadiaControlProps } from "@certn/forms";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

import { sortResidencesByDate } from "../residences-sort-utils";

function getAddressWithUnit(residence: any) {
  return residence.address.unit_number
    ? `${residence.address.unit_number}-${residence.address.street_address}`
    : residence.address.street_address;
}

export function ResidencesArrayControlSummary(props: CascadiaControlProps) {
  const { t } = useTranslation();
  const { formatDisplayDate } = useFormatDisplayDate();

  const countriesList: { const: string; title: string }[] =
    (props.schema as any)?.properties?.address?.properties?.country?.oneOf ??
    [];

  return (
    <>
      {props.data
        ?.slice()
        .sort(sortResidencesByDate)
        .map((residence: any, index: number) => (
          <OuterContentItem
            key={index}
            title={getAddressWithUnit(residence)}
            subtitle={formatDisplayDate({
              start_date: residence.start_date,
              end_date: residence.end_date,
            })}
            tag={
              !residence.end_date && (
                <PrimaryTag type="subtle">
                  <Trans>Current</Trans>
                </PrimaryTag>
              )
            }
            testID={`residences-summary-address-${index + 1}`}
          >
            <InnerContentItem
              label={t("Address")}
              testID={`address-summary-address-${index + 1}`}
            >
              {getAddressWithUnit(residence)}
              <br />
              {residence.address.locality}{" "}
              {residence.address.administrative_division_1},{" "}
              {countriesList.find(
                ({ const: key }) => key === residence.address.country
              )?.title ?? residence.address.country}
              <br />
              {residence.address.postal_code}
            </InnerContentItem>

            <InnerContentItem
              label={t("Start date")}
              testID={`residences-summary-start-date-${index + 1}`}
            >
              {formatDate(residence.start_date, "MMMM yyyy")}
            </InnerContentItem>
            {residence.end_date && (
              <InnerContentItem
                label={t("End date")}
                testID={`residences-summary-end-date-${index + 1}`}
              >
                {formatDate(residence.end_date, "MMMM yyyy")}
              </InnerContentItem>
            )}
          </OuterContentItem>
        ))}
    </>
  );
}
